// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.required-survey-container {
	overflow: hidden !important;
	position: fixed;
	height: 100%;
	width: 100%;
	background: #f5f5f5;
}

.required-survey-container .current-survey-overlay {
	display: none;
}

`, "",{"version":3,"sources":["webpack://./src/widgets/Survey/SingleSurveyPages/RequiredSurvey.css"],"names":[],"mappings":"AAAA;CACC,2BAA2B;CAC3B,eAAe;CACf,YAAY;CACZ,WAAW;CACX,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd","sourcesContent":[".required-survey-container {\n\toverflow: hidden !important;\n\tposition: fixed;\n\theight: 100%;\n\twidth: 100%;\n\tbackground: #f5f5f5;\n}\n\n.required-survey-container .current-survey-overlay {\n\tdisplay: none;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
